export const selectors = {
    searchForm: '#search-form',
    sortDropdown: '.js-search-sort',
    clearSearchButton: '.js-clear-search',
    clearAllButton: '.js-clear-all',
    searchButton: '.js-search-button',
    allClearXButtons: '.js-clear-search, .js-clear-date',
    dropdowns: '.js-search-dropdown',
    searchInput: 'input[name="q"]',
    resultsContainer: '.js-search-results',
    tabLinks: '.js-search-tab-links .js-tab-link',
    tabContents: '.js-search-tab-content',
    totalCountElement: '.js-search-total-count',
    tabLinkCountElement: (section) => `.js-tab-link[href*="tab=${section}"] .js-tab-link-count`,
    updatedAfterInput: '.js-updated-after',
    updatedBeforeInput: '.js-updated-before',
    clearDateButtons: '.js-clear-date',
    searchTypeRadios: '.js-search-type',
    resourceTypeDropdown: '.js-resource-type',
    expandFilterButton: '.js-resource-search-form .js-expand-filter',
    expandableFilter: '.js-resource-search-form .js-expandable-filter-wrapper',
    noResultsContainer: '.js-no-results',
    allDropdowns: '.js-dropdown',
    loadingSkeletons: '.js-search-skeletons'
};

export const elements = {
    searchForm: document.querySelector(selectors.searchForm),
    sortDropdown: document.querySelector(selectors.sortDropdown),
    clearSearchButton: document.querySelector(selectors.clearSearchButton),
    clearAllButton: document.querySelector(selectors.clearAllButton),
    searchButton: document.querySelector(selectors.searchButton),
    dropdowns: document.querySelectorAll(selectors.dropdowns),
    searchInput: document.querySelector(selectors.searchInput),
    updatedAfterInput: document.querySelector(selectors.updatedAfterInput),
    updatedBeforeInput: document.querySelector(selectors.updatedBeforeInput),
    clearDateButtons: document.querySelectorAll(selectors.clearDateButtons),
    searchTypeRadios: document.querySelectorAll(selectors.searchTypeRadios),
    resourceTypeDropdown: document.querySelector(selectors.resourceTypeDropdown),
    tabLinks: document.querySelectorAll(selectors.tabLinks),
    resultsContainer: document.querySelector(selectors.resultsContainer),
    expandFilterButton: document.querySelector(selectors.expandFilterButton),
    expandableFilter: document.querySelector(selectors.expandableFilter),
    noResultsContainer: document.querySelector(selectors.noResultsContainer),
    allDropdowns: document.querySelectorAll(selectors.allDropdowns),
    loadingSkeletons: document.querySelector(selectors.loadingSkeletons),
};
